export default function ConversationHeaderTeam(props) {
    const { identity } = props;

    return (
        <div className="flex-container-horz">
            <div className="name">{identity.name}</div>
        </div>
    )
}